<template>
  <v-row style="margin: 20px auto">
    <v-col cols="12">


      <v-row>
        <v-col cols="3" sm="3">
          <v-select update:modelValue="true" clearable :menu-props="{ maxHeight: 'unset' }" chips label="template"
            :items="Object.keys(this.templates)" v-model="template" @update:modelValue="templateChanged"></v-select>
        </v-col>

        <v-col cols="7" sm="7">
        
          <v-row>
            <v-col cols="6" sm="6">
              <div>
                <v-text-field class="date-picker" @click="from_menu ^= true" :value="getDate(from_data, 'from')" :active="true" readonly variant="outlined"
                label="From" append-icon="mdi-calendar-filter"></v-text-field>

              <v-date-picker v-if="from_menu" @update:modelValue="from_menu = false"  v-model="from_data" text="test"
                height="530" position="absolute"></v-date-picker>
              </div>
            </v-col>  
            <v-col cols="6" sm="6">
              <div>
                <!-- [matrah] legacy: :value="getDate(from_data, 'to')" -->
                <v-text-field class="date-picker" @click="to_menu ^= true" :value="getDate(to_data, 'to')" :active="true" readonly variant="outlined"
                label="To" append-icon="mdi-calendar-filter"></v-text-field>

              <!-- [matrah] legacy (bound both pickers to from_data, so "To" could never differ):
              <v-date-picker v-if="to_menu" @update:modelValue="to_menu = false"  v-model="from_data" text="test"
                height="530" position="absolute"></v-date-picker>
              -->
              <v-date-picker v-if="to_menu" @update:modelValue="to_menu = false"  v-model="to_data" text="test"
                height="530" position="absolute"></v-date-picker>
              </div>
            </v-col>  
          </v-row>

          
        </v-col>

        <v-col cols="2" sm="2">
          <v-btn 
          :disabled=" !template || !to || !from"
          @click="sendToUserHandler" style="margin-bottom: 15px"> Filter </v-btn>
        </v-col>
      </v-row>


    </v-col>
  </v-row>

  <v-divider class="border-opacity-75"></v-divider>
  <div>
    <v-table fixed-header fixed-footer height="600px">
      <thead>
        <tr>
          <!-- <th class="text-left">
            Template Name
          </th> -->
          <th class="text-left">
            From
          </th>
          <th class="text-left">
            To
          </th>
          <th class="text-left">
            sent
          </th>
          <th class="text-left">
            delivered
          </th>
          <th class="text-left">
            read
          </th>
          <!-- [matrah] per-button clicks from Meta template_analytics (CLICKED) -->
          <th class="text-left">
            clicks
          </th>
          <th v-if="hasReplies" class="text-left">
            replies
          </th>

        </tr>
      </thead>
      <tbody v-if="templateStatus.length > 0">
        <template v-for="(item, idx) in templateStatus" :key="rowKey(item, idx)">
        <tr :class="{ 'row-expandable': hasClicks(item), 'row-expanded': isExpanded(rowKey(item, idx)) }"
          @click="hasClicks(item) && toggleExpand(rowKey(item, idx))">
          <!-- <td>{{ item.template_name }}</td> -->
          <td>{{ momentFilter(new Date(item.start * 1000)) }}</td>
          <td>{{ momentFilter(new Date(item.end * 1000)) }}</td>

          <td>{{ item.sent }}</td>
          <td>{{ item.delivered }}</td>
          <!-- [matrah] legacy: <td>{{ item.delivered }}</td> (read column showed delivered) -->
          <td>{{ item.read ?? '—' }}</td>
          <td>
            <div class="d-flex align-center" style="gap: 6px">
              <v-chip size="small" variant="tonal" :color="clickTotal(item) > 0 ? 'secondary' : 'grey'">
                <v-icon icon="mdi-cursor-default-click-outline" size="14" class="mr-1" />
                {{ clickTotal(item) }}
              </v-chip>
              <v-btn v-if="hasClicks(item)" size="x-small" variant="text"
                :icon="isExpanded(rowKey(item, idx)) ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                :title="isExpanded(rowKey(item, idx)) ? 'Hide buttons' : 'Show per-button clicks'"
                @click.stop="toggleExpand(rowKey(item, idx))" />
            </div>
          </td>
          <td v-if="hasReplies">{{ item.replies ?? '—' }}</td>
          <!-- <td>{{ item.failed }}</td> -->
        </tr>
        <tr v-if="hasClicks(item) && isExpanded(rowKey(item, idx))" class="row-breakdown">
          <td :colspan="hasReplies ? 7 : 6" class="pa-0">
            <div class="breakdown">
              <div class="text-caption text-medium-emphasis mb-1">Clicks per button</div>
              <div class="d-flex flex-wrap" style="gap: 8px">
                <v-card v-for="(btn, bIdx) in item.clicked" :key="bIdx" variant="outlined" class="breakdown-card">
                  <v-card-text class="py-2 px-3 d-flex align-center" style="gap: 10px">
                    <v-icon :icon="buttonIcon(btn.type)" size="18" color="primary" />
                    <div>
                      <div class="font-weight-medium">{{ btn.button_content || btn.type || 'Button' }}</div>
                      <div class="text-caption text-medium-emphasis">{{ buttonTypeLabel(btn.type) }}</div>
                    </div>
                    <v-chip size="small" color="secondary" variant="flat" class="ml-auto">{{ btn.count ?? 0 }}</v-chip>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </td>
        </tr>
        </template>

      </tbody>
      <tbody  class="no-data-body" v-else>
        <p class="text-center no-data-content">
          no data
        </p>
      </tbody>

    </v-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useUserStore } from '../stores/user'
import { useTemplateStore } from '../stores/template'
import { useGlobalStore } from '../stores/global'

import moment from 'moment'
// [matrah] toasts
import { toastApiError } from '../utils/notify'

export default {
  name: 'TemplatesStatusView',
  components: {},
  data: () => ({
    picker: '2018-03-02',
    from_date: null,
    to_date: null,
    // [matrah] separate model for the "To" picker + expanded click breakdown rows
    to_data: null,
    expandedRows: [],

    from: null,
    to: null,

    datesFormate: [],

    from_menu: false,
    to_menu: false,

    url: '',
    selected: [],
    // products: [],
    select: [],
    items: [],
    isErrorToSend: true,
    show: false,
    template: null,
    template_id: null,

    templatesData: [],
    variables: [],
    header: [],
    errors: [],
    headerErrors: [],
    excelUsers: [],
    platform: 'whatsapp',
    usersAddedFrom: ['all', 'excel_sheet', 'url', 'api', 'conversation'],
    usersFrom: {
      all: [],
      excel_sheet: [],
      url: [],
      api: [],
      conversation: [],
    },
    userFrom: null,
    currentUsersList: [],
  }),
  computed: {
    ...mapState(useUserStore, [
      'userList',
      'user',
      'admin',
      'filterUsers',
      'instagramUsers',
      'whatsappUsers',
      'gerUsersAddedFrom',
    ]),
    ...mapState(useTemplateStore, ['templates', 'products', 'templatesKeys', 'templateStatus']),
    likesAllUsers() {
      return this.select.length === this.gerUsersAddedFrom(this.userFrom).length
    },
    likesSomeUsers() {
      return this.select.length > 0
    },
    // [matrah] "Replies" is a placeholder until the server provides it; hide the column otherwise.
    hasReplies() {
      return (this.templateStatus || []).some((item) => item && item.replies !== undefined && item.replies !== null)
    },
  },
  methods: {
    ...mapActions(useUserStore, ['getUsers', 'sendTemplateMessage']),
    ...mapActions(useTemplateStore, ['getTemplates', 'getTemplateStatus']),
    ...mapActions(useGlobalStore, ['setAlertMessage']),

    // [matrah] per-button click helpers
    rowKey(item, idx) {
      return item?._id || `${item?.start}-${item?.end}-${idx}`
    },
    hasClicks(item) {
      return Array.isArray(item?.clicked) && item.clicked.length > 0
    },
    clickTotal(item) {
      if (typeof item?.clicked_total === 'number') return item.clicked_total
      if (!this.hasClicks(item)) return 0
      return item.clicked.reduce((sum, b) => sum + (Number(b.count) || 0), 0)
    },
    isExpanded(key) {
      return this.expandedRows.includes(key)
    },
    toggleExpand(key) {
      const i = this.expandedRows.indexOf(key)
      if (i > -1) this.expandedRows.splice(i, 1)
      else this.expandedRows.push(key)
    },
    buttonIcon(type) {
      const t = String(type || '').toLowerCase()
      if (t.includes('url')) return 'mdi-open-in-new'
      if (t.includes('phone')) return 'mdi-phone-outline'
      if (t.includes('quick')) return 'mdi-reply-outline'
      return 'mdi-gesture-tap-button'
    },
    buttonTypeLabel(type) {
      const t = String(type || '').toLowerCase()
      if (t.includes('url')) return 'URL button'
      if (t.includes('phone')) return 'Phone button'
      if (t.includes('quick')) return 'Quick reply'
      return type || 'Button'
    },

    cancelHandler() {
      console.log('cancelHandler')
      this.menu = false;
      // this.menuFlag = false
    },
    okHandler() {
      console.log('okHandler', this.dates)
      this.menu = false;
      this.getDate(this.dates);
    },
   
    templateChanged(value) {
      console.log('template changed - ', value, this.templates)
      this.template_id = this.templates[value]['id'];
    },

    async sendToUserHandler() {
      console.log(this.template_id, this.from, this.to)

      this.expandedRows = []
      const res = await this.getTemplateStatus({
        template: this.template_id,
        start: this.from,
        end: this.to
      });

      if(!res.success){
        this.setAlertMessage( {
          display: true,
          // [matrah] legacy: text: res.message,
          text: res.message || 'Could not load the statistics.',
          class: "error",
        })
      } else {
        // [matrah]
        const rows = Array.isArray(this.templateStatus) ? this.templateStatus.length : 0
        this.setAlertMessage({
          display: true,
          text: rows ? `Statistics loaded (${rows} row${rows === 1 ? '' : 's'}).` : 'No statistics for this template in the selected period.',
          class: rows ? 'success' : 'info',
        })
      }
      console.log({
        res
      })
    },
    momentFilter: function (date) {
      return moment(date).format('yy-MM-DD')
    },
    getDate(date, type) {
      let res = '';
      if(date){
        console.log('getDate', {date});
        res = new Date(date);
        console.log({ date: Math.floor(res.getTime() / 1000) }) 
        if(type === 'from')
          this.from = Math.floor(res.getTime() / 1000)
        if(type === 'to')
          this.to =  Math.floor(res.getTime() / 1000)

        res = this.momentFilter(res);

      }     
      return res;
    },

    async getRangeOfDates(startDate, endDate) {

      let start = new Date(new Date(startDate).setUTCHours(0, 0, 0, 0));
      let end = new Date(new Date(endDate).setUTCHours(0, 0, 0, 0));

      start.setDate(start.getDate() + 1);
      end.setDate(end.getDate() + 1);


      console.log({
        start, end
      })
      const date = new Date(start.getTime());

      const dates = [];

      while (date <= end) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      return dates;



    },
    usersAddedFromHandler(value) {
      console.log({ value }, value === null)
      if (value === null) {
        this.select = []
        this.currentUsersList = []
      } else {
        this.currentUsersList = this.gerUsersAddedFrom(value)
        // switch (value) {
        //   case 'all':
        //     this.currentUsersList = this.gerUsersAddedFrom('all')
        //     break
        //   case 'excel_sheet':
        //     this.currentUsersList = this.gerUsersAddedFrom('excel_sheet')
        //     break
        //   case 'url':
        //     this.currentUsersList = this.gerUsersAddedFrom('url')
        //     break
        //   case 'api':
        //     this.currentUsersList = this.gerUsersAddedFrom('api')
        //     break
        //   case 'conversation':
        //     this.currentUsersList = this.gerUsersAddedFrom('conversation')
        //     break
        // }
      }
    },

    saveHandler() {
      console.log('saveHandler', {
        val: this.dates
      })
    }
  },

  async mounted() {
    console.log('templates | mounted')
    document.title = 'Templates'
    // [matrah] legacy: await this.getTemplates(); await this.getUsers()  (unhandled rejections)
    try {
      await this.getTemplates()
    } catch (error) {
      toastApiError(error, 'Could not load templates from Meta')
    }
    try {
      await this.getUsers()
    } catch (error) {
      toastApiError(error, 'Could not load contacts')
    }
  },
}
</script>

<style scoped>
.template-container {
  height: 80vh;
  overflow-x: auto;
}

/* .products-container {
  height: 350px !important;
  overflow: auto;
} */

.no-data-body{
  position: relative;
}
.no-data-content{
  position: absolute;
    right: 50%;
}

.v-date-picker{
  z-index: 90 !important;
    top: 153px !important;
}

.text-danger {
  color: #f44336;
}

/* [matrah] click breakdown rows */
.row-expandable {
  cursor: pointer;
}

.row-expanded > td {
  background: #f6f8f6;
}

.row-breakdown > td {
  background: #f6f8f6;
  border-bottom: 1px solid #dfe6e0;
}

.breakdown {
  padding: 10px 16px 14px;
}

.breakdown-card {
  min-width: 220px;
  border-color: #dfe6e0;
  background: #fff;
}
</style>
